import script from "./EditButton.vue?vue&type=script&setup=true&lang=js"
export * from "./EditButton.vue?vue&type=script&setup=true&lang=js"

import "./EditButton.vue?vue&type=style&index=0&id=1447b0ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1447b0ec"]])

export default __exports__